import React, { useCallback, useEffect, useState } from "react";

import Footer from "../Header/Footer";
import Header from "../Header/Header";
import Config from "../Header/Config";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';


export default function Enquiry() {


  const today = new Date().toISOString().split("T")[0];

  const [customer_name, setcustomer_name] = useState('');
  const [contact_number, setcontact_number] = useState('');
  const [date, setdate] = useState('');
  const [model_name, setmodel_name] = useState('');

  // Validation states
  const [errors, setErrors] = useState({
    customer_name: "",
    contact_number: "",
    date: "",
    model_name: "",
  });
  const [touched, setTouched] = useState({
    customer_name: false,
    contact_number: false,
    date: false,
    model_name: false,
  });
  const [submitAttempted, setSubmitAttempted] = useState(false);

  const apiUrl = Config.apiUrl;

  const capitalizeWords = (str) => {
    if (!str) return '';
    return str
      .toString()
      .split(/\s+/)
      .map((w) => (w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  // Validation functions
  const validateCustomerName = (value) => {
    if (!value || value.trim() === "") {
      return "Customer name is required";
    }
    if (value.trim().length < 2) {
      return "Customer name must be at least 2 characters";
    }
    if (value.trim().length > 100) {
      return "Customer name must not exceed 100 characters";
    }
    // Allow letters, spaces, and common name characters
    if (!/^[a-zA-Z\s\.\-']+$/.test(value.trim())) {
      return "Customer name can only contain letters, spaces, dots, hyphens, and apostrophes";
    }
    return "";
  };

  const validateContactNumber = (value) => {
    if (!value || value.trim() === "") {
      return "Mobile number is required";
    }
    if (!/^\d+$/.test(value)) {
      return "Mobile number must contain only digits";
    }
    if (value.length !== 10) {
      return "Mobile number must be exactly 10 digits";
    }
    return "";
  };

  const validateDate = (value) => {
    if (!value || value.trim() === "") {
      return "Date is required";
    }
    const selectedDate = new Date(value);
    selectedDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    // Allow today's date and past dates, but not future dates
    if (selectedDate > today) {
      return "Date cannot be in the future";
    }
    return "";
  };

  const validateModelName = (value) => {
    if (value && value.trim().length > 0) {
      if (value.trim().length < 2) {
        return "Model name must be at least 2 characters if provided";
      }
      if (value.trim().length > 50) {
        return "Model name must not exceed 50 characters";
      }
      // Allow alphanumeric, spaces, hyphens, and underscores
      if (!/^[a-zA-Z0-9\s\-_]+$/.test(value.trim())) {
        return "Model name can only contain letters, numbers, spaces, hyphens, and underscores";
      }
    }
    return "";
  };

  // Validate all fields
  const validateAll = () => {
    const newErrors = {
      customer_name: validateCustomerName(customer_name),
      contact_number: validateContactNumber(contact_number),
      date: validateDate(date),
      model_name: validateModelName(model_name),
    };
    setErrors(newErrors);
    return !newErrors.customer_name && !newErrors.contact_number && !newErrors.date && !newErrors.model_name;
  };

  const [isDataChanged, setIsDataChanged] = useState(false);
  const navigate = useNavigate();

  // ..............................< Unsaved Navigation>...............................
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDataChanged) {
        const message = "You have unsaved changes. Are you sure you want to leave?";
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDataChanged]);

  // Callback function to handle navigation from the header
  const handleHeaderNavigation = () => {
    if (isDataChanged && !window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
      // If there are unsaved changes and the user clicks cancel, prevent navigation
      return false;
    }
    return true; // Allow navigation
  };


  // ...........................<Cancle Model>.......................

  const cancelModel = () => {
    if (isDataChanged) {
      const confirmCancel = window.confirm('You have unsaved changes. Are you sure you want to cancel?');
      if (!confirmCancel) {
        return;
      }
    }

    setcustomer_name('');
    setcontact_number('');
    setdate('');
    setmodel_name('');
    setErrors({
      customer_name: "",
      contact_number: "",
      date: "",
      model_name: "",
    });
    setTouched({
      customer_name: false,
      contact_number: false,
      date: false,
      model_name: false,
    });
    setSubmitAttempted(false);
    setIsDataChanged(false);

    // Use the navigate function to redirect to another page
    // replace '/your-redirect-path' with the desired path
  };

  const handleCustomerNameChange = (e) => {
    const value = capitalizeWords(e.target.value);
    setcustomer_name(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.customer_name || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        customer_name: validateCustomerName(value),
      }));
    }
  };

  const handleCustomerNameBlur = () => {
    setTouched((prev) => ({ ...prev, customer_name: true }));
    setErrors((prev) => ({
      ...prev,
      customer_name: validateCustomerName(customer_name),
    }));
  };

  const handleContactNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setcontact_number(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.contact_number || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        contact_number: validateContactNumber(value),
      }));
    }
  };

  const handleContactNumberBlur = () => {
    setTouched((prev) => ({ ...prev, contact_number: true }));
    setErrors((prev) => ({
      ...prev,
      contact_number: validateContactNumber(contact_number),
    }));
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    setdate(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.date || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        date: validateDate(value),
      }));
    }
  };

  const handleDateBlur = () => {
    setTouched((prev) => ({ ...prev, date: true }));
    setErrors((prev) => ({
      ...prev,
      date: validateDate(date),
    }));
  };

  const handleModelNameChange = (e) => {
    const value = e.target.value.toUpperCase();
    setmodel_name(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.model_name || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        model_name: validateModelName(value),
      }));
    }
  };

  const handleModelNameBlur = () => {
    setTouched((prev) => ({ ...prev, model_name: true }));
    setErrors((prev) => ({
      ...prev,
      model_name: validateModelName(model_name),
    }));
  };


  //.........................................[ Add Enquiry ]...........................................



  const AddEnquiry = async (e) => {
    e.preventDefault();

    // Mark submit as attempted
    setSubmitAttempted(true);

    // Mark all fields as touched
    setTouched({
      customer_name: true,
      contact_number: true,
      date: true,
      model_name: true,
    });

    // Validate all fields
    if (!validateAll()) {
      return;
    }

    let item = {
      customer_name: customer_name.trim(),
      contact_number: contact_number.trim(),
      date: date,
      model_name: model_name.trim(),
    };
    try {
      let result = await fetch(`${apiUrl}/save_enquiry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });

      if (result.ok) {
        toast.success("Enquiry added successfully", { autoClose: 1000 });
        setcustomer_name("");
        setcontact_number("");
        setdate("");
        setmodel_name("");
        setErrors({
          customer_name: "",
          contact_number: "",
          date: "",
          model_name: "",
        });
        setTouched({
          customer_name: false,
          contact_number: false,
          date: false,
          model_name: false,
        });
        setSubmitAttempted(false);
        setIsDataChanged(false);

        console.log(item);
        
        // Reload the page after successful submission
        setTimeout(() => {
          window.location.reload();
        }, 1500);

      } else {
        toast.error("Failed to add Enquiry");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to add Enquiry");
    }
  };




  return (
    <>
      <ToastContainer />
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header onNavigate={handleHeaderNavigation} />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Enquiry Details</h4>

                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Add New Enquiry</h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={AddEnquiry} noValidate>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-customer-name"
                          >
                            Customer Name <span className="text-danger">*</span>
                          </label>
                          <div className="input-group input-group-merge">
                            <input
                              type="text"
                              id="basic-default-customer-name"
                              className={`form-control ${(touched.customer_name && errors.customer_name) || (submitAttempted && !customer_name.trim()) ? 'is-invalid' : touched.customer_name && !errors.customer_name && customer_name ? 'is-valid' : ''}`}
                              placeholder="Enter Customer Name"
                              aria-label="Customer Name"
                              aria-describedby="customer-name-error"
                              value={customer_name}
                              onChange={handleCustomerNameChange}
                              onBlur={handleCustomerNameBlur}
                            />
                          </div>
                          {((touched.customer_name && errors.customer_name) || (submitAttempted && !customer_name.trim())) && (
                            <div className="invalid-feedback d-block" id="customer-name-error">
                              {errors.customer_name || "Customer name is required"}
                            </div>
                          )}
                          {touched.customer_name && !errors.customer_name && customer_name && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-contact-number"
                          >
                            Mobile Number <span className="text-danger">*</span>
                          </label>
                          <div className="input-group input-group-merge">
                            <input
                              type="text"
                              id="basic-default-contact-number"
                              className={`form-control ${(touched.contact_number && errors.contact_number) || (submitAttempted && !contact_number.trim()) ? 'is-invalid' : touched.contact_number && !errors.contact_number && contact_number ? 'is-valid' : ''}`}
                              placeholder="Enter Mobile Number"
                              aria-label="Mobile Number"
                              aria-describedby="contact-number-error"
                              value={contact_number}
                              onChange={handleContactNumberChange}
                              onBlur={handleContactNumberBlur}
                              maxLength={10}
                            />
                          </div>
                          {((touched.contact_number && errors.contact_number) || (submitAttempted && !contact_number.trim())) && (
                            <div className="invalid-feedback d-block" id="contact-number-error">
                              {errors.contact_number || "Mobile number is required"}
                            </div>
                          )}
                          {touched.contact_number && !errors.contact_number && contact_number && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                          <small className="text-muted">
                            Enter 10 digit mobile number
                          </small>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-date"
                          >
                            Date <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            className={`form-control ${(touched.date && errors.date) || (submitAttempted && !date.trim()) ? 'is-invalid' : touched.date && !errors.date && date ? 'is-valid' : ''}`}
                            id="basic-default-date"
                            placeholder="Enter date"
                            value={date}
                            onChange={handleDateChange}
                            onBlur={handleDateBlur}
                            max={today}
                          />
                          {((touched.date && errors.date) || (submitAttempted && !date.trim())) && (
                            <div className="invalid-feedback d-block">
                              {errors.date || "Date is required"}
                            </div>
                          )}
                          {touched.date && !errors.date && date && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-model-name"
                          >
                            Model Name <small className="text-muted">(Optional)</small>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${(touched.model_name && errors.model_name) ? 'is-invalid' : touched.model_name && !errors.model_name && model_name ? 'is-valid' : ''}`}
                            id="basic-default-model-name"
                            placeholder="Enter Model Name"
                            value={model_name}
                            onChange={handleModelNameChange}
                            onBlur={handleModelNameBlur}
                          />
                          {touched.model_name && errors.model_name && (
                            <div className="invalid-feedback d-block">
                              {errors.model_name}
                            </div>
                          )}
                          {touched.model_name && !errors.model_name && model_name && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                        </div>

                        {/* <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-phone"
                          >
                            Opening Stock
                          </label>
                          <input
                            type="number"
                            id="basic-default-phone"
                            className="form-control phone-mask"
                            placeholder="Enter Opening Stock"
                            value={openingStock}
                            onChange={(e) => setOpeningStock(e.target.value)}
                          />
                        </div> */}


                        <div className="col-12">
                          <div className="col-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", marginRight: "5px" }}
                            >
                              Submit
                            </button>

                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={cancelModel}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
